import { tw } from "@careinfo/tailwind";
import { Undo2, Redo2, Save, Eye, Settings, Delete, Trash } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useBodyEditor } from "../../../context/GrapeJsBodyContext";
import useEditor from "../../../hooks/useEditor";
import SeoIcon from "../../../icons/SeoIcon";
import { classNames } from "../../../utils/classNames";
import APIS from "../../../constant/Endpoint";
import useGetHook from "../../../hooks/useGetHook";

const NavBar = () => {
  const { handleDeviceChange, handlePanelChange } = useEditor();
  const navigate = useNavigate();
  const { editor: bodyEditor } = useBodyEditor();
  const { id } = useParams();
  const { data: pageData } = useGetHook({
    queryKey: [`page-${id}`],
    url: `${APIS.PAGE}${id}/`,
    params: {},
  });

  return (
    <div
      className={tw`h-[50px] bg-gray-600 text-white flex items-center justify-between w-full  top-0 sticky z-1  px-4`}
    >
      <button
        className={tw`focus:outline-none px-4 py-2 border border-white rounded-md  `}
        type="button"
        onClick={() => navigate(-1)}
      >
        Back
      </button>
      <div className={tw` flex items-center justify-center items-center `}>
        {bodyEditor?.config?.deviceManager?.devices?.map((device: any) => (
          <div
            key={device?.id}
            className={classNames(
              bodyEditor?.getDevice() === device.name ? tw`bg-primary` : "",
              tw`${device?.className} h-8 w-8 cursor-pointer p-2 hover:bg-primary-light flex items-center justify-center `
            )}
            onClick={() => handleDeviceChange(device?.id)}
          ></div>
        ))}
        <div className={tw`px-4`}>
          <p>[{pageData?.title}]</p>
        </div>
      </div>

      {/* Panels */}
      <div className={tw`flex items-center justify-center gap-4`}>
        <button
          onClick={() => handlePanelChange("undo")}
          className={tw`flex items-center gap-2 focus:outline-none `}
        >
          <Undo2 size={20} />
        </button>
        <button
          onClick={() => handlePanelChange("redo")}
          className={tw`flex items-center gap-2  focus:outline-none`}
        >
          <Redo2 size={20} />
        </button>
        <button
          onClick={() => handlePanelChange("save")}
          className={tw`flex items-center gap-2  focus:outline-none`}
        >
          <Save size={20} />
        </button>
        <button
          onClick={() => handlePanelChange("setting")}
          className={tw`flex items-center gap-2  focus:outline-none`}
        >
          <Settings size={20} />
        </button>
        <button
          onClick={() => handlePanelChange("seo")}
          className={tw`flex items-center gap-2  focus:outline-none`}
        >
          <SeoIcon />
        </button>
        <button
          onClick={() => handlePanelChange("visibility")}
          className={tw`flex items-center gap-2  focus:outline-none`}
        >
          <Eye size={20} />
        </button>
        <button
          onClick={() => handlePanelChange("trash")}
          className={tw`flex items-center gap-2  focus:outline-none`}
        >
          <Trash size={20} />
        </button>
        <button
          onClick={() => handlePanelChange("outline")}
          className={tw`focus:outline-none`}
        >
          <div
            className={tw`w-4 h-4 border-2 border-dotted border-white focus:outline-none outline-none`}
          ></div>
        </button>
      </div>
    </div>
  );
};

export default NavBar;
